import { TotalSalesListResponse } from '@/modules/reports/totalSales/services/apiValidationSchemas.ts'
import { QuotesCollectionListResponse } from '@/modules/reports/quotesCollection/services/apiValidationSchemas.ts'
import { SalesByBranchListResponse } from '@/modules/reports/salesByBranch/services/apiValidationSchemas.ts'
import { AppleDevicesOverdueListResponse } from '@/modules/reports/appleDevicesOverdue/services/apiValidationSchemas.ts'
import { OverdueQuotasListListResponse } from '@/modules/reports/overdueQuotasList/services/apiValidationSchemas.ts'
import { AllyOverdueDevicesListResponse } from '@/modules/reports/allyOverdueDevices/services/apiValidationSchemas.ts'
import { AutomaticPayments } from '@/modules/reports/automaticPayments/types/AutomaticPayments.ts'
import { ApprovedPaymentsByEmployees } from '@/modules/reports/approvedPaymentsByEmployees/types/ApprovedPaymentsByEmployees.ts'
import { MarketplaceAllyPendingProductsListResponse } from '@/modules/reports/marketplaceAllyPendingProducts/services/apiValidationSchemas.ts'
import { ReferralCodesListResponse } from '@/modules/reports/referralCodes/services/apiValidationSchemas.ts'
import { BranchOfficeListResponse } from '@/modules/reports/branchOfficeDaysWithoutSales/services/apiValidationSchemas.ts'
import { MovistarClubSalesListResponse } from '@/modules/reports/movistarClub/services/apiValidationSchemas.ts'
import { WeppaPlusClientsListResponse } from '@/modules/reports/weppaPlusClients/services/apiValidationSchemas.ts'
import { PreassignedCreditSummaryListResponse } from '@/modules/reports/preassignedCreditSummary/services/apiValidationSchemas.ts'
import { ZoneUSalesListResponse } from '@/modules/reports/zoneU/services/apiValidationSchemas.ts'
import { ClientGeolocationListResponse } from '@/modules/reports/geolocation/services/apiValidation/clientGeolocationApiValidation.ts'
import { UserGeolocationListResponse } from '@/modules/reports/geolocation/services/apiValidation/userGeolocationApiValidation.ts'
import { AssignedMotorcyclesListResponse } from '@/modules/reports/assignedMotorcycles/services/apiValidationSchemas.ts'
import { CashTopUpsListResponse } from '@/modules/reports/cashTopUps/services/apiValidations/cashTopUpsApiValidation.ts'

export const alliesList: { data: TotalSalesListResponse; message: string } = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        commercialAllyName: 'Weppa',
        month: '1',
        year: '2025',
        totalSales: '200',
        totalInitial: '50',
        paymentByQuotes: '25',
        profit: '17',
        totalPayment: '600',
        sectorId: '225',
        sectorName: 'Torres',
        cityId: '55',
        cityName: 'Barquisimeto',
        stateId: '13',
        stateName: 'Lara',
        soldQuantity: '20'
      },
      {
        id: '2',
        commercialAllyName: 'Yuca',
        month: '1',
        year: '2025',
        totalSales: '200',
        totalInitial: '50',
        paymentByQuotes: '25',
        profit: '17',
        totalPayment: '600',
        sectorId: '225',
        sectorName: 'Torres',
        cityId: '55',
        cityName: 'Barquisimeto',
        stateId: '13',
        stateName: 'Lara',
        soldQuantity: '20'
      }
    ],
    total: {
      totalInitial: '200',
      paymentByQuotes: '300',
      totalSales: '350',
      profit: '4080',
      totalPayment: '500'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1
    }
  }
}

export const salesByBranchList: {
  data: SalesByBranchListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        branchOfficeName: 'Sucursal Centro',
        documentNumber: '12345678',
        registerNumber: 'REG001',
        createdAt: '15/01/2025',
        brand: 'Apple',
        model: 'iPhone 14',
        imei: '123456789012345',
        cost: '800',
        initialTotal: '200',
        paymentByQuotes: '600',
        totalPayment: '900',
        rentability: '100'
      },
      {
        id: '2',
        branchOfficeName: 'Sucursal Norte',
        documentNumber: '87654321',
        registerNumber: 'REG002',
        createdAt: '16/01/2025',
        brand: 'Samsung',
        model: 'Galaxy S23',
        imei: '987654321098765',
        cost: '700',
        initialTotal: '150',
        paymentByQuotes: '550',
        totalPayment: '800',
        rentability: '100'
      }
    ],
    total: {
      cost: '1500',
      initialTotal: '350',
      paymentByQuotes: '1150',
      totalPaymentTotal: '1700',
      rentabilityTotal: '200'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1
    }
  }
}

export const automaticPaymentsList: {
  data: AutomaticPayments
  message: string
} = {
  message: 'OK',
  data: {
    total: 1,
    totalPages: 1,
    limit: 20,
    currentPage: 0,
    data: [
      {
        id: 'bc4f7536-21bd-418f-b6f3-8a31096e8322',
        transferNumber: '25956323083',
        transferDate: '2025-09-16T00:00:00Z',
        transferAmount: 10190,
        bank: {
          id: 26,
          name: 'Banco Nacional de Crédito C.A., Banco Universal',
          code: '0191',
          literalCode: '',
          photo: null,
          active: true
        },
        paymentType: {
          id: 1,
          code: 'MOVIL_PAY',
          name: 'Pago Móvil',
          photo: null,
          active: true
        },
        currencyResponse: {
          code: 'BS',
          exchangeBuy: 36.5,
          exchangeSell: 36.5,
          mainCurrency: false
        },
        transaction: {
          id: 156,
          amount: 279.18,
          description: '',
          reference: 'REC16092025-024558',
          type: 'RECHARGE',
          status: 'COMPLETED',
          wallet: {
            id: 'f336d0cc-9934-4ab7-aaef-de36539bf5b0-client',
            balance: 257.68,
            documentNumber: 'AEX413017',
            currency: {
              code: 'USD',
              exchangeBuy: 1,
              exchangeSell: 1,
              mainCurrency: true
            },
            status: 'ACTIVE'
          },
          createAt: '2025-09-16T17:40:53.716630Z',
          details: {
            originalAmount: '10190',
            originalCurrency: 'BS',
            currencyCalculation: {
              BS: {
                amount: 10190.07,
                exchangeRate: 36.5
              },
              USD: {
                amount: 279.18,
                exchangeRate: 1
              }
            }
          }
        },
        payPhone: '584247318639',
        bankOrigin: {
          id: 3,
          name: 'Banco Mercantil C.A., Banco Universal',
          code: '0105',
          literalCode: '',
          photo: null,
          active: true,
          origin: true
        },
        exchangeRate: 36.5,
        file: ''
      }
    ],
    summary: {
      totalUsd: '279.18',
      totalBs: '10190.07'
    }
  }
}

export const appleDevicesOverdueList: {
  data: AppleDevicesOverdueListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        clientName: 'Grisel Estrada',
        documentNumber: 'AEX413017',
        email: 'genamorado88+3@gmail.com',
        phone: '+581234567899',
        branchOfficeName: 'Plaza Empresarial Sur',
        commercialAllyName: 'WEPPA',
        commercialAllyId: '1',
        modelName: 'M50',
        brandName: 'MAXWEST',
        imei: '123456',
        createAt: '19/09/2025',
        createdBy: 'Grisel Estrada Enamorado',
        firstOverdueInstallmentDate: '03/10/2025',
        totalDebt: '52.00',
        totalQuotes: '2'
      },
      {
        id: '2',
        clientName: 'Minina lopez',
        documentNumber: 'AEX413017',
        email: 'genamorado88+3@gmail.com',
        phone: '+581234567899',
        branchOfficeName: 'Plaza Empresarial Sur',
        commercialAllyName: 'WEPPA',
        commercialAllyId: '1',
        modelName: 'M50',
        brandName: 'MAXWEST',
        imei: '123456',
        createAt: '19/09/2025',
        createdBy: 'Grisel Estrada Enamorado',
        firstOverdueInstallmentDate: '03/10/2025',
        totalDebt: '52.00',
        totalQuotes: '2'
      }
    ],
    total: {
      totalDebt: '2000',
      totalQuotes: '8'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1
    }
  }
}

export const overdueQuotasListList: OverdueQuotasListListResponse = {
  items: [
    {
      id: '1',
      clientName: 'María González',
      documentNumber: 'V12345678',
      email: 'maria.gonzalez@email.com',
      phone: '+584121234567',
      branchOfficeName: 'Sucursal Centro',
      commercialAllyName: 'WEPPA',
      commercialAllyId: '1',
      modelName: 'iPhone 14',
      brandName: 'Apple',
      imei: '123456789012345',
      createAt: '15/01/2025',
      createdBy: 'Juan Pérez',
      firstOverdueInstallmentDate: '15/02/2025',
      totalDebt: '150.00',
      totalQuotes: '3',
      management: 'INTERNA',
      overdueDebt: '56',
      rentability: '12'
    },
    {
      id: '2',
      clientName: 'Carlos Rodríguez',
      documentNumber: 'V87654321',
      email: 'carlos.rodriguez@email.com',
      phone: '+584129876543',
      branchOfficeName: 'Sucursal Norte',
      commercialAllyName: 'YUCA',
      commercialAllyId: '2',
      modelName: 'Galaxy S23',
      brandName: 'Samsung',
      imei: '987654321098765',
      createAt: '20/01/2025',
      createdBy: 'Ana López',
      firstOverdueInstallmentDate: '20/02/2025',
      totalDebt: '200.00',
      totalQuotes: '4',
      management: 'INTERNA',
      overdueDebt: '56',
      rentability: '12'
    }
  ],
  totals: {
    totalDebt: '350.00',
    totalQuotes: '7',
    totalOverdueDebt: '4543'
  },
  pagination: {
    next: false,
    prev: false,
    start: 1,
    limit: 20,
    end: 1,
    range: [1],
    count: 2,
    pages: 1,
    total: 1
  }
}

export const allyOverdueDevicesList: {
  data: AllyOverdueDevicesListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        commercialAllyId: '1',
        commercialAllyName: 'WEPPA',
        totalQuotes: '15',
        totalDebt: '2500.00'
      },
      {
        commercialAllyId: '2',
        commercialAllyName: 'WEPPA',
        totalQuotes: '15',
        totalDebt: '2500.00'
      }
    ],
    total: {
      totalDebt: '3700.00',
      totalQuotes: '23'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1
    }
  }
}

export const approvedPaymentsByEmployeesList: {
  data: ApprovedPaymentsByEmployees
  message: string
} = {
  message: 'OK',
  data: {
    total: 0,
    totalPages: 0,
    limit: 20,
    currentPage: 0,
    data: [],
    summary: {
      totalUsd: '0',
      totalBs: '0'
    }
  }
}

export const marketplaceAllyPendingProductsList: {
  data: MarketplaceAllyPendingProductsListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        id: '9',
        modelId: '7',
        modelName: '11 LITE 5G',
        brandId: '65',
        brandName: 'LENOVO',
        branchOfficeId: '1',
        branchOfficeName: 'Plaza Central Este',
        cost: '55.00',
        additionalCost: '0.00',
        initial: '7.00',
        initialTotal: '7.00',
        paymentByQuotes: '48.00',
        extraPayment: '0.00',
        totalPayment: '72.00',
        clientId: '32',
        clienName: 'DANILO MILAN ARAUJO',
        documentNumber: 'AEX413017',
        createdAt: '18/09/2025'
      },
      {
        id: '8',
        modelId: '15',
        modelName: 'EDGE 40 NEO',
        brandId: '3',
        brandName: 'MOTOROLA',
        branchOfficeId: '1',
        branchOfficeName: 'Plaza Central Este',
        cost: '399.99',
        additionalCost: '0.00',
        initial: '156.00',
        initialTotal: '168.00',
        paymentByQuotes: '219.99',
        extraPayment: '12.00',
        totalPayment: '280.00',
        clientId: '5',
        clienName: 'JESUS HERNANDEZ BARRIOS',
        documentNumber: 'AAJ332971',
        createdAt: '15/09/2025'
      },
      {
        id: '6',
        modelId: '16',
        modelName: 'A14',
        brandId: '4',
        brandName: 'SAMSUNG',
        branchOfficeId: '1',
        branchOfficeName: 'Plaza Central Este',
        cost: '169.99',
        additionalCost: '0.00',
        initial: '68.00',
        initialTotal: '68.00',
        paymentByQuotes: '101.99',
        extraPayment: '0.00',
        totalPayment: '132.00',
        clientId: '13',
        clienName: 'prueba prueba',
        documentNumber: 'DS6656565',
        createdAt: '11/09/2025'
      }
    ],
    total: {
      cost: '5979.97',
      additionalCost: '1100.00',
      initial: '1553.00',
      initialTotal: '3125.00',
      paymentByQuotes: '2382.97',
      extraPayment: '498.00',
      totalPayment: '4514.00'
    },
    status: true,
    pagination: {
      next: true,
      prev: false,
      start: 1,
      end: 10,
      range: [1, 2],
      count: 10,
      pages: 2,
      total: 13,
      limit: 10
    }
  }
}

export const data = {
  data: {
    url: 'http://weppa2.com/reports/2025/12/30/branch_offices_sales_695438c7013d9092118180.csv'
  }
}

export const referralCodesList: {
  data: ReferralCodesListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        clientId: '37',
        email: 'leo.cty@gmail.com',
        totalPurchases: 4,
        clientName: 'LEANDRO CARMENATY PUPO'
      },
      {
        clientId: '32',
        email: 'genamorado88+3@gmail.com',
        totalPurchases: 1,
        clientName: 'DANILO MILAN ARAUJO'
      }
    ],
    total: {
      totalClients: '330',
      totalPurchases: '730'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1
    }
  }
}

export const branchOfficesList: {
  data: BranchOfficeListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        branchOfficeId: '1',
        branchOfficeName: 'Plaza Central Este',
        commercialAllyName: 'WEPPA',
        commercialAllyId: '1',
        branchOfficeStatus: 'Activa',
        lastSaleDate: '14/11/2025',
        sectorName: 'Centro Hist\u00f3rico',
        sectorId: '1',
        cityName: 'La Gran Caracas',
        cityId: '46',
        stateName: 'Distrito Capital',
        stateId: '10'
      },
      {
        branchOfficeId: '4',
        branchOfficeName: 'Plaza Empresarial Sur',
        commercialAllyName: 'WEPPA',
        commercialAllyId: '1',
        branchOfficeStatus: 'Activa',
        lastSaleDate: null,
        sectorName: 'Centro Hist\u00f3rico',
        sectorId: '1',
        cityName: 'La Gran Caracas',
        cityId: '46',
        stateName: 'Distrito Capital',
        stateId: '10'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 3,
      pages: 1,
      total: 1
    }
  }
}

export const weppaPlusClientsList: {
  data: WeppaPlusClientsListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        documentNumber: '12345678',
        registerNumber: '3876306',
        clientName: 'Juan Pérez',
        modelName: 'TABLE 8',
        modelId: '2263',
        brandName: 'APPLE',
        brandId: '12',
        contractDate: '2026-06-22 10:30:00',
        contractedTermValidity: '12',
        serviceEndDate: '2027-06-22 10:30:00',
        amount: '75.00',
        procurementChannel: 'App'
      },
      {
        documentNumber: '87654321',
        registerNumber: '3876307',
        clientName: 'María Gómez',
        modelName: 'GALAXY A15',
        modelId: '1840',
        brandName: 'SAMSUNG',
        brandId: '7',
        contractDate: '2026-06-20 15:45:00',
        contractedTermValidity: '6',
        serviceEndDate: '2026-12-20 15:45:00',
        amount: '40.00',
        procurementChannel: 'Weppa Gestión'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      limit: 20,
      range: [1],
      count: 2,
      pages: 1,
      total: 2
    }
  }
}

export const movistarClubList: {
  data: MovistarClubSalesListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        id: '37',
        documentNumber: '112701206',
        name: 'LEANDRO',
        lastName: 'CARMENATY PUPO',
        clienName: 'LEANDRO CARMENATY PUPO',
        phone: '+593980629597',
        registerNumber: '1761673578987',
        branchOfficeName: 'Prueba',
        modelName: 'SERVICIO RECARGA',
        brandName: 'CRÉDITO',
        assignmentDate: '26/10/2025',
        cost: '15.00'
      },
      {
        id: '38',
        documentNumber: '112701206',
        name: 'Juana',
        lastName: 'Alemana',
        clienName: 'Pepa',
        phone: '+593980629597',
        registerNumber: '1761673578987',
        branchOfficeName: 'Prueba',
        modelName: 'SERVICIO RECARGA',
        brandName: 'CRÉDITO',
        assignmentDate: '26/10/2025',
        cost: '150.00'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1
    }
  }
}

export const zoneUList: {
  data: ZoneUSalesListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        documentNumber: '123456789',
        name: 'CARLOS',
        lastName: 'RODRIGUEZ PEREZ',
        clienName: 'CARLOS RODRIGUEZ PEREZ',
        phone: '+593987654321',
        registerNumber: '1234567890123',
        branchOfficeName: 'Sucursal Centro',
        modelName: 'GALAXY S23',
        brandName: 'SAMSUNG',
        assignmentDate: '15/01/2025',
        cost: '450.00'
      },
      {
        id: '2',
        documentNumber: '987654321',
        name: 'MARIA',
        lastName: 'GONZALEZ LOPEZ',
        clienName: 'MARIA GONZALEZ LOPEZ',
        phone: '+593912345678',
        registerNumber: '9876543210987',
        branchOfficeName: 'Sucursal Norte',
        modelName: 'IPHONE 14',
        brandName: 'APPLE',
        assignmentDate: '20/01/2025',
        cost: '800.00'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1
    }
  }
}

export const quotesCollectionList: {
  data: QuotesCollectionListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      { paymentDay: '09/06/2026', totalQuotes: 42, totalPaid: '1850.00' }
    ],
    total: { totalQuotes: 500, totalPaid: '21000.00' },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 1,
      range: [1],
      count: 1,
      pages: 1,
      total: 1
    }
  }
}

export const cashOutList = {
  message: 'OK',
  data: [
    {
      id: '3557',
      debt: '407.23',
      amount: '407.23',
      amountBs: '143634.09',
      exchange: '352.71',
      status: 'PROCESADO',
      commercialAllyName: 'MD - MEGAPHONE VIP',
      createdAt: '23/01/2026',
      updatedAt: null,
      createdBy: null,
      accountNumber: '01050068141068506997',
      commercialAllyId: '392'
    },
    {
      id: '3556',
      debt: '1377.65',
      amount: '1377.65',
      amountBs: null,
      exchange: null,
      status: 'ERROR',
      commercialAllyName: 'AD - LUXURY',
      createdAt: '23/01/2026',
      updatedAt: null,
      createdBy: null,
      accountNumber: '01340389983891401237',
      commercialAllyId: '177'
    },
    {
      id: '3555',
      debt: '80.09',
      amount: '80.09',
      amountBs: '28248.54',
      exchange: '352.71',
      status: 'PROCESADO',
      commercialAllyName: 'MD - NATAN ELECTRONICS MATURIN',
      createdAt: '23/01/2026',
      updatedAt: null,
      createdBy: null,
      accountNumber: '01340442994423017486',
      commercialAllyId: '953'
    },
    {
      id: '3554',
      debt: '61.76',
      amount: '61.76',
      amountBs: '21783.37',
      exchange: '352.71',
      status: 'PENDIENTE',
      commercialAllyName: 'MD - COL CEL',
      createdAt: '23/01/2026',
      updatedAt: null,
      createdBy: null,
      accountNumber: '01050098281098211308',
      commercialAllyId: '712'
    },
    {
      id: '3553',
      debt: '358.00',
      amount: '358.00',
      amountBs: '126270.18',
      exchange: '352.71',
      status: 'PROCESADO',
      commercialAllyName: 'MD - HISTORY STORE',
      createdAt: '23/01/2026',
      updatedAt: null,
      createdBy: null,
      accountNumber: '01340030020301033365',
      commercialAllyId: '238'
    },
    {
      id: '3552',
      debt: '138.96',
      amount: '138.96',
      amountBs: '49012.58',
      exchange: '352.71',
      status: 'PROCESADO',
      commercialAllyName: 'MD - INVERSIONES JACK CELULAR 2012',
      createdAt: '23/01/2026',
      updatedAt: null,
      createdBy: null,
      accountNumber: '01710042476003086274',
      commercialAllyId: '431'
    },
    {
      id: '3551',
      debt: '184.58',
      amount: '184.58',
      amountBs: '65103.21',
      exchange: '352.71',
      status: 'PROCESADO',
      commercialAllyName: 'MD - CELULAR SHOPPING',
      createdAt: '23/01/2026',
      updatedAt: null,
      createdBy: null,
      accountNumber: '01080086210100089237',
      commercialAllyId: '36'
    }
  ]
}

export const clientGeolocation: { data: ClientGeolocationListResponse } = {
  data: {
    results: [
      {
        id: 59,
        clientName: 'Otro ASDFGH',
        loginAt: '04/03/2026',
        latitude: '14.89220060',
        longitude: '-92.27349680',
        userAgent: 'Client app',
        ipAddress: '189.148.19.20'
      },
      {
        id: 58,
        clientName: 'Otro ASDFGH',
        loginAt: '04/03/2026',
        latitude: '14.89223480',
        longitude: '-92.27346450',
        userAgent: 'Client app',
        ipAddress: '189.148.19.20'
      },
      {
        id: 57,
        clientName: 'Otro ASDFGH',
        loginAt: '04/03/2026',
        latitude: '14.89223460',
        longitude: '-92.27347580',
        userAgent: 'Client app',
        ipAddress: '189.148.19.20'
      },
      {
        id: 56,
        clientName: 'Otro ASDFGH',
        loginAt: '03/03/2026',
        latitude: '14.89222660',
        longitude: '-92.27348330',
        userAgent: 'Client app',
        ipAddress: '189.148.6.180'
      },
      {
        id: 55,
        clientName: 'Otro ASDFGH',
        loginAt: '03/03/2026',
        latitude: '14.89222430',
        longitude: '-92.27348120',
        userAgent: 'Client app',
        ipAddress: '189.148.47.236'
      },
      {
        id: 54,
        clientName: 'Otro ASDFGH',
        loginAt: '03/03/2026',
        latitude: '14.89224560',
        longitude: '-92.27347900',
        userAgent: 'Client app',
        ipAddress: '189.148.45.98'
      },
      {
        id: 53,
        clientName: 'Otro ASDFGH',
        loginAt: '03/03/2026',
        latitude: '14.89223160',
        longitude: '-92.27346230',
        userAgent: 'Client app',
        ipAddress: '189.148.45.98'
      },
      {
        id: 52,
        clientName: 'Otro ASDFGH',
        loginAt: '03/03/2026',
        latitude: '14.89222430',
        longitude: '-92.27348130',
        userAgent: 'Client app',
        ipAddress: '189.148.6.180'
      },
      {
        id: 51,
        clientName: 'Otro ASDFGH',
        loginAt: '03/03/2026',
        latitude: '14.89222430',
        longitude: '-92.27348130',
        userAgent: 'Client app',
        ipAddress: '189.148.6.180'
      },
      {
        id: 50,
        clientName: 'Otro ASDFGH',
        loginAt: '03/03/2026',
        latitude: '14.89223960',
        longitude: '-92.27347030',
        userAgent: 'Client app',
        ipAddress: '189.148.47.236'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: true,
      prev: false,
      start: 1,
      end: 10,
      range: [1, 2, 3, 4, 5],
      count: 10,
      pages: 5,
      total: 50,
      limit: 10
    }
  }
}

export const userGeolocation: { data: UserGeolocationListResponse } = {
  data: {
    results: [
      {
        id: 241,
        userName: 'Jesus Montoya',
        commercialAllyName: 'Ally_55',
        loginAt: '09/03/2026',
        latitude: '321.00000000',
        longitude: '123.00000000',
        userAgent: '24234',
        ipAddress: '23424'
      },
      {
        id: 240,
        userName: 'Yosvani Nasco',
        commercialAllyName: 'Ally_4',
        loginAt: '09/03/2026',
        latitude: '-25.50700304',
        longitude: '-49.30091733',
        userAgent:
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36',
        ipAddress: '10.78.139.69'
      },
      {
        id: 239,
        userName: 'Yosvani Nasco',
        commercialAllyName: 'Ally_4',
        loginAt: '06/03/2026',
        latitude: '-25.50729251',
        longitude: '-49.30096742',
        userAgent:
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36',
        ipAddress: '10.78.139.170'
      },
      {
        id: 233,
        userName: 'Yosvani Nasco',
        commercialAllyName: 'Ally_4',
        loginAt: '06/03/2026',
        latitude: '-25.50729610',
        longitude: '-49.30097119',
        userAgent:
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36',
        ipAddress: '10.78.139.170'
      },
      {
        id: 232,
        userName: 'Leandro Carmenaty Pupo',
        commercialAllyName: 'Ally_4',
        loginAt: '06/03/2026',
        latitude: '-0.14154344',
        longitude: '-78.46292579',
        userAgent:
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36',
        ipAddress: '10.78.139.38'
      },
      {
        id: 231,
        userName: 'Leandro Carmenaty Pupo',
        commercialAllyName: 'Ally_4',
        loginAt: '06/03/2026',
        latitude: '-0.14172975',
        longitude: '-78.46287538',
        userAgent:
          'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36',
        ipAddress: '10.78.139.170'
      },
      {
        id: 230,
        userName: 'Yosvani Nasco',
        commercialAllyName: 'Ally_4',
        loginAt: '06/03/2026',
        latitude: '-25.50711535',
        longitude: '-49.30093166',
        userAgent:
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36',
        ipAddress: '10.78.139.69'
      },
      {
        id: 229,
        userName: 'AVENIDA MARIÑO CANGURO',
        commercialAllyName: 'Ally_4',
        loginAt: '05/03/2026',
        latitude: '23.09293650',
        longitude: '-82.42032450',
        userAgent:
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:148.0) Gecko/20100101 Firefox/148.0',
        ipAddress: '10.78.139.69'
      },
      {
        id: 227,
        userName: 'Yosvani Nasco',
        commercialAllyName: 'Ally_4',
        loginAt: '05/03/2026',
        latitude: '-25.50698385',
        longitude: '-49.30098403',
        userAgent:
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36',
        ipAddress: '10.78.139.69'
      },
      {
        id: 226,
        userName: 'Leandro Carmenaty Pupo',
        commercialAllyName: 'Ally_4',
        loginAt: '05/03/2026',
        latitude: '-0.14154484',
        longitude: '-78.46291493',
        userAgent:
          'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36',
        ipAddress: '10.78.139.38'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: true,
      prev: false,
      start: 1,
      end: 10,
      range: [1, 2, 3, 4, 5],
      count: 10,
      pages: 23,
      total: 228,
      limit: 10
    }
  }
}

export const assignedMotorcyclesList: {
  data: AssignedMotorcyclesListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        id: '426672',
        branchOfficeName: 'Weppa Centro',
        clientName: 'Pedro Juanete',
        documentNumber: '21212121',
        plateNumber: 'AX1E75FZ',
        brandName: 'Suzuki',
        modelName: 'GN125',
        cost: '1000.00',
        preAssignmentDate: '03/06/2026',
        verificationDate: '03/06/2026 18:54'
      },
      {
        id: '426673',
        branchOfficeName: 'Weppa Este',
        clientName: 'Maria Lopez',
        documentNumber: '15445566',
        plateNumber: null,
        brandName: 'Honda',
        modelName: 'CB150',
        cost: '1200.00',
        preAssignmentDate: '01/06/2026',
        verificationDate: 'No verificado'
      }
    ],
    total: {
      totalCost: '2200.00',
      totalRecords: '2'
    },
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      limit: 20,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2
    }
  }
}

export const cashTopUpsList: CashTopUpsListResponse = {
  items: [
    {
      id: '3f2b9c14-8d51-4a0e-9c77-2b6f5a1e77d0',
      uuid: '01234_01754062985123',
      type: 'CREDIT',
      typeLabel: 'A plazos',
      status: 'SUCCESS',
      createdAt: '2026-08-12T14:23:05',
      processedAt: '2026-08-12T14:23:11',
      operator: 'MOVISTAR',
      serviceCode: '41',
      serviceName: 'Movistar Prepago',
      number: '04141234567',
      userClientId: 8821,
      clientId: 15043,
      clientName: 'María Fernanda Rojas',
      clientDocument: '18456789',
      clientEmail: 'mariaf.rojas@gmail.com',
      clientPhone: '04141234567',
      amountBs: 980.0,
      amountUsd: 4.0,
      exchangeRate: 245.0,
      approvalCode: 'A73921',
      payallTransactionId: 'PA-99231882',
      creditDetail: {
        creditId: 204517,
        registerNumber: '17540629851',
        cost: 4.0,
        fee: 0.5,
        totalPayment: 4.5,
        quoteId: 331902,
        quoteAmount: 4.5,
        quoteStatus: 'PENDIENTE',
        dueAt: '2026-08-27T00:00:00Z',
        paymentDate: null
      },
      walletDetail: null
    },
    {
      id: 'b81c0a77-4f3d-42be-9a10-c0d9e2f45511',
      uuid: '01234_01754049112877',
      type: 'WALLET',
      typeLabel: 'De contado',
      status: 'SUCCESS',
      createdAt: '2026-08-12T10:31:52',
      processedAt: '2026-08-12T10:31:57',
      operator: 'CANTV',
      serviceCode: '56',
      serviceName: 'CANTV ABA',
      number: '02123456789',
      userClientId: 7410,
      clientId: 13288,
      clientName: 'José Antonio Pérez',
      clientDocument: '14987654',
      clientEmail: 'japerez@hotmail.com',
      clientPhone: '04246667788',
      amountBs: 2450.0,
      amountUsd: 10.0,
      exchangeRate: 245.0,
      approvalCode: 'A73810',
      payallTransactionId: 'PA-99231455',
      creditDetail: null,
      walletDetail: {
        transactionId: 884512,
        reference: 'SER12082026-473921',
        status: 'COMPLETED',
        amount: 10.0,
        createdAt: '2026-08-12T10:31:56Z'
      }
    }
  ],
  totals: {
    totalRecharges: 148,
    totalAmountBs: 214830.0,
    totalAmountUsd: 876.86,
    creditCount: 61,
    creditAmountUsd: 302.15,
    walletCount: 87,
    walletAmountUsd: 574.71
  },
  pagination: {
    next: true,
    prev: false,
    start: 1,
    end: 10,
    range: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    count: 10,
    pages: 15,
    total: 148,
    limit: 10
  }
}

export const preassignedCreditSummaryList: {
  data: PreassignedCreditSummaryListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        id: 173,
        registerNumber: '351735894420716',
        cost: 630,
        additionalCost: 18,
        initialCash: 171,
        initialWallet: 0,
        initialTotal: 171,
        totalPayment: null,
        paymentByQuotes: null,
        clientId: 674934,
        clientName: 'GLENDA ANDREINA SOLORZANO ARAGORT',
        documentNumber: '18600530',
        branchOfficeId: 6,
        branchOfficeName: 'Weppa',
        commercialAllyId: 4,
        commercialAllyName: 'Weppa',
        creditId: 652590,
        createdAt: '08/10/2026',
        requiredInitialByLevel: 153,
        additionalPaymentByClient: null,
        quotes: [
          { dueAt: '22/10/2026', amount: 91 },
          { dueAt: '05/11/2026', amount: 91 },
          { dueAt: '19/11/2026', amount: 91 },
          { dueAt: '03/12/2026', amount: 91 },
          { dueAt: '17/12/2026', amount: 91 },
          { dueAt: '31/12/2026', amount: 91 },
          { dueAt: '14/01/2027', amount: 91 },
          { dueAt: '28/01/2027', amount: 91 }
        ],
        totalQuotesAmount: 728
      },
      {
        id: 174,
        registerNumber: '354553703510149',
        cost: 450,
        additionalCost: 0,
        initialCash: 90,
        initialWallet: 60,
        initialTotal: 150,
        totalPayment: null,
        paymentByQuotes: 300,
        clientId: 512301,
        clientName: 'JUAN CARLOS PEREZ MARQUEZ',
        documentNumber: '25411500',
        branchOfficeId: 12,
        branchOfficeName: 'Sucursal Centro',
        commercialAllyId: 7,
        commercialAllyName: 'Tecno Aliado',
        creditId: 652611,
        createdAt: '09/10/2026',
        requiredInitialByLevel: 150,
        additionalPaymentByClient: 0,
        quotes: [
          { dueAt: '26/10/2026', amount: 75 },
          { dueAt: '09/11/2026', amount: 75 },
          { dueAt: '23/11/2026', amount: 75 },
          { dueAt: '07/12/2026', amount: 75 }
        ],
        totalQuotesAmount: 300
      },
      {
        id: 175,
        registerNumber: '358802114467390',
        cost: 820,
        additionalCost: 25,
        initialCash: 0,
        initialWallet: 200,
        initialTotal: 225,
        totalPayment: 25,
        paymentByQuotes: 595,
        clientId: 498772,
        clientName: 'MARIA GABRIELA RODRIGUEZ LOPEZ',
        documentNumber: '19876543',
        branchOfficeId: 15,
        branchOfficeName: 'Sucursal Este',
        commercialAllyId: 9,
        commercialAllyName: 'Movil Plus',
        creditId: 652640,
        createdAt: '10/10/2026',
        requiredInitialByLevel: 200,
        additionalPaymentByClient: 25,
        quotes: [
          { dueAt: '15/10/2026', amount: 99.17 },
          { dueAt: '29/10/2026', amount: 99.17 },
          { dueAt: '12/11/2026', amount: 99.17 },
          { dueAt: '26/11/2026', amount: 99.17 },
          { dueAt: '10/12/2026', amount: 99.17 },
          { dueAt: '24/12/2026', amount: 99.15 }
        ],
        totalQuotesAmount: 595
      },
      {
        id: 176,
        registerNumber: '352119087745521',
        cost: 299.99,
        additionalCost: 0,
        initialCash: 60,
        initialWallet: 40,
        initialTotal: 100,
        totalPayment: 0,
        paymentByQuotes: 199.99,
        clientId: 701145,
        clientName: 'LUIS ALBERTO MENDOZA RIVAS',
        documentNumber: '27345612',
        branchOfficeId: 6,
        branchOfficeName: 'Weppa',
        commercialAllyId: 4,
        commercialAllyName: 'Weppa',
        creditId: 652702,
        createdAt: '11/10/2026',
        requiredInitialByLevel: 100,
        additionalPaymentByClient: 0,
        quotes: [
          { dueAt: '26/10/2026', amount: 50 },
          { dueAt: '09/11/2026', amount: 50 },
          { dueAt: '23/11/2026', amount: 50 },
          { dueAt: '07/12/2026', amount: 49.99 }
        ],
        totalQuotesAmount: 199.99
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 4,
      limit: 20,
      range: [1],
      count: 4,
      pages: 1,
      total: 4
    }
  }
}
